import React from 'react';
export function BrandHeader() {
  return <header className="bg-brand-white border-b border-brand-text/5 py-6 md:py-8 px-5 sm:px-6" data-id="element-135">
      <div className="max-w-7xl mx-auto flex items-center justify-center" data-id="element-136">
        <div className="flex items-center gap-4 sm:gap-5" data-id="element-137">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-138">
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16" aria-label="Ingresos Online Desde Casa logo" data-id="element-139">
              {/* Partial circle frame */}
              <path d="M32 4C16.536 4 4 16.536 4 32" stroke="#C8A96A" strokeWidth="3" strokeLinecap="round" data-id="element-140" />
              <path d="M60 32C60 47.464 47.464 60 32 60" stroke="#C8A96A" strokeWidth="3" strokeLinecap="round" data-id="element-141" />

              {/* Stylized leaf */}
              <path d="M32 16C32 16 22 22 22 34C22 42 27 48 32 48C32 48 32 38 32 16Z" fill="#C8A96A" data-id="element-142" />
              <path d="M32 16C32 16 42 22 42 34C42 42 37 48 32 48C32 48 32 38 32 16Z" fill="#C8A96A" opacity="0.85" data-id="element-143" />
              {/* Center vein */}
              <path d="M32 18V46" stroke="#1C3928" strokeWidth="1.5" strokeLinecap="round" data-id="element-144" />
            </svg>
          </div>

          {/* Brand text */}
          <div className="flex flex-col" data-id="element-145">
            <h1 className="font-serif font-bold text-brand-green leading-none tracking-tight text-xl sm:text-2xl md:text-3xl" data-id="element-146">
              INGRESOS ONLINE
              <span className="font-bold align-super text-[0.5em] ml-0.5" data-id="element-147">
                ™
              </span>
            </h1>
            <p className="text-[10px] sm:text-xs md:text-sm font-semibold tracking-[0.2em] text-brand-text/55 uppercase mt-1" data-id="element-148">
              Desde Casa
            </p>
            <p className="hidden sm:block text-[10px] md:text-xs text-brand-text/45 mt-2 tracking-wide" data-id="element-149">
              Ecommerce <span className="text-brand-gold" data-id="element-150">•</span> Amazon{' '}
              <span className="text-brand-gold" data-id="element-151">•</span> Negocios Digitales
            </p>
          </div>
        </div>
      </div>

      {/* Mobile-only subtext (full width below) */}
      <p className="sm:hidden text-center text-[10px] text-brand-text/45 mt-4 tracking-wide" data-id="element-152">
        Ecommerce <span className="text-brand-gold" data-id="element-153">•</span> Amazon{' '}
        <span className="text-brand-gold" data-id="element-154">•</span> Negocios Digitales
      </p>
    </header>;
}